// Plot.ly custom layouts

// Layout: Population vs. Year

export const layoutPop = {
  title: "Population vs. Year",
  xaxis: {
    title: "Year",
    type: "date",
    tickformat: "%Y",
    // showline: true,
  },
  yaxis: {
    title: "Population",
    showline: true,
  },
  yaxis2: {
    title: "Population",
    overlaying: "x",
    side: "right",
    showline: true,
  },
  legend: {
    orientation: "h",
    y: 4,
  },
  width: "100vw",
  autosize: true,
};

// Layout: GDP vs. Year
export const layoutGDP = {
  title: "% GDP Change Compared to Baseline",
  xaxis: {
    title: "Year",
    showline: true,
    zeroline: false,
    showticklabels: true,
    type: "date",
    tickformat: "%Y",
  },
  yaxis: {
    title: "% GDP Change",
    showline: true,
    zeroline: false,
  },
  legend: {
    orientation: "h",
    y: 4,
  },
  width: "100vw",
  autosize: true,
};

// Layout: Budget vs. Year
export const layoutBudget = {
  title: "Budget and Costs Vs. Year",
  xaxis: {
    title: "Year",
    showline: true,
    zeroline: false,
    showticklabels: true,
    type: "date",
    tickformat: "%Y",
  },
  yaxis: {
    title: "Amount (in $)",
    showline: true,
    zeroline: false,
  },
  legend: {
    orientation: "h",
    y: 4,
  },
  width: "100vw",
  autosize: true,
};

// Layout: HRT vs. Year
export const layoutHRT = {
  title: "HRX vs. Year",
  xaxis: {
    title: "Year",
    showline: true,
    zeroline: false,
    showticklabels: true,
    type: "date",
    tickformat: "%Y",
  },
  yaxis: {
    title: "HRX",
    showline: true,
    zeroline: false,
  },
  legend: {
    orientation: "h",
    y: 4,
  },
  width: "100vw",
  autosize: true,
};

// Layout: Equity vs. Year
export const layoutEQT = {
  title: "Equity vs. Year",
  xaxis: {
    title: "Year",
    showline: true,
    zeroline: false,
    showticklabels: true,
    type: "date",
    tickformat: "%Y",
  },
  yaxis: {
    title: "Equity ",
    showline: true,
    zeroline: false,
  },
  legend: {
    orientation: "h",
    y: 4,
  },
  width: "100vw",
  autosize: true,
};

// Layout: Favorability vs. Year
export const layoutFavorability = {
  title: "% Favorability vs. Year",
  xaxis: {
    title: "Year",
    showline: true,
    zeroline: false,
    showticklabels: true,
    type: "date",
    tickformat: "%Y",
  },
  yaxis: {
    title: "% Favorability",
    showline: true,
    zeroline: false,
  },
  legend: {
    orientation: "h",
    y: 4,
  },
  width: "100vw",
  autosize: true,
};

// Layout: Dsicord vs. Year
export const layoutDiscord = {
  title: "Discord vs. Year",
  xaxis: {
    title: "Year",
    showline: true,
    zeroline: false,
    showticklabels: true,
    type: "date",
    tickformat: "%Y",
  },
  yaxis: {
    title: "Discord",
    showline: true,
    zeroline: false,
  },
  legend: {
    orientation: "h",
    y: 4,
  },
  width: "100vw",
  autosize: true,
};

// Layout: Favorability vs. Year
export const layoutEmployment = {
  title: "% Refugees Employed vs. Year",
  xaxis: {
    title: "Year",
    showline: true,
    zeroline: false,
    showticklabels: true,
    type: "date",
    tickformat: "%Y",
  },
  yaxis: {
    title: "% Employment",
    showline: true,
    zeroline: false,
  },
  legend: {
    orientation: "h",
    y: 4,
  },
  width: "100vw",
  autosize: true,
};
